import axios from "axios";

export default {
  namespaced: true,
  state: {
    postings: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    postingsMessage: ''
  },
  mutations: {
    DO_NOTHING(state) {
      state.isReceiving = false;
    },
    RECEIVED_POSTINGS(state, payload) {
      state.postings = payload;
      state.isReceiving = false;
    },
    RECEIVING_POSTINGS(state) {
      state.isReceiving = true;
    },
    RECEIVED_POSTING(state, payload) {
      state = Object.assign(state, {
        postings: [...state.postings, payload],
        isReceiving: false,
      })
    },
    RECEIVING_POSTING(state) {
      state.isReceiving = true;
    },
    UPDATED_POSTING(state, payload) {
      let index = state.postings.findIndex(jobposting => jobposting._id === payload._id);
      state = Object.assign(state, {
        postings: state.postings.map((jobposting, i) => {
          if (i === index) {
            return Object.assign({}, jobposting, payload);
          }
          return jobposting;
        }),
        isUpdating: false,
        postingsMessage: 'JobPostings has been updating!',
      })
    },
    UPDATING_POSTING(state) {
      state.isUpdating = true;
    },
    DELETED_POSTING(state, payload) {
      let indexToDelete = state.postings.findIndex(jobposting => jobposting._id === payload._id);
      let postings = [...state.postings];
      postings.splice(indexToDelete, 1);
      state = Object.assign(state, {
        postings: [...postings],
        isDeleting: false,
        idToDelete: null,
        postingsMessage: 'JobPosting has been Deleted!',
      });
    },
    DELETING_POSTING(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    deleteJobPostingRequest({dispatch}, payload) {
      dispatch("deletingJobPosting", payload);
      let token = localStorage.getItem('token')
      let url = 'https://api.tradexc.com:3000/delete/jobposting/' + payload._id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      axios({method: "delete", url: url,headers: headers})
      .then(function (response) {
        console.log(response.data);
        dispatch("deleteJobPosting", {_id: payload._id});
      })
      .catch(function (error) {
        console.log(error.data);
      });
    },
    async deleteJobApplicationRequest({dispatch}, payload) {
      try{
        dispatch("deletingJobPosting", payload);
        let token = localStorage.getItem("token");
        let url ="https://api.tradexc.com:3000/delete/jobapplication/" + payload._id;
        let headers = {"Content-Type": "application/json",Authorization: "Bearer " + token,};
  
        let response = await axios({ method: "delete", url: url, headers: headers });
        dispatch("deleteJobPosting", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async getJobPostingsRequest({dispatch}) {
      dispatch("receivingJobPostings");
      var token = localStorage.getItem('token');
      var url = 'https://api.tradexc.com:3000/get/jobpostings';
      var headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      return axios({method: "get",url: url,headers: headers})
      .then(res => {
        dispatch("receiveJobPostings", res.data);
      })
    },
    async insertJobPostingRequest({dispatch}, payload) {
      dispatch("receivingJobPosting");
      let  token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/insert/jobposting';
      let data = payload;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "post", url: url, headers: headers, data: data})
      .then((response)=> {
        dispatch("receiveJobPosting", response.data);
      })
      .catch((error) => {
        this.alertmessage = error.response.data.error;
      });	
    },
    async insertPostingDetailRequest({dispatch}, payload) {
      try{
        dispatch("doNothing");
        console.log(payload)
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/insert/jobdetail/' + payload.postingid;
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    updateJobPostingRequest({dispatch}, payload) {
      dispatch("updatingJobPosting");
      let id = payload._id;
      delete payload['_id'];

      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/update/jobposting/' + id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      axios({method: "put", url: url,headers: headers,data: payload})
      .then(function (res) {
        dispatch("updateJobPosting", res.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });
    },
    async updatePostingDetailRequest({dispatch}, payload) {
      try{
        dispatch("doNothing");
        let id = payload._id;
        delete payload['_id'];
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/update/jobdetail/' + id;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    doNothing({commit}) {
      commit("DO_NOTHING")
    },
    receiveJobPostings({commit}, payload) {
      commit("RECEIVED_POSTINGS", payload)
    },
    receivingJobPostings({commit}) {
      commit("RECEIVING_POSTINGS")
    },
    receiveJobPosting({commit}, payload) {
      commit("RECEIVED_POSTING", payload)
    },
    receivingJobPosting({commit}) {
      commit("RECEIVING_POSTING")
    },
    updateJobPosting({commit}, payload) {
      commit("UPDATED_POSTING", payload)
    },
    updatingJobPosting({commit}) {
      commit("UPDATING_POSTING")
    },
    deleteJobPosting({commit}, payload) {
      commit("DELETED_POSTING", payload)
    },
    deletingJobPosting({commit}, payload) {
      commit("DELETING_POSTING", payload)
    }
  },
};
